// extracted by mini-css-extract-plugin
export default {"root":"Avatar_root__EXfY-","sm":"Avatar_sm__jNnHA","lg":"Avatar_lg__Jm2hc","avatarText":"Avatar_avatarText__1fFbl"};